module.exports = __webpack_public_path__ + "static/media/group-3.c76806ca.svg";